import React, { useState } from 'react';
import { FilterBar, DESTINATION_OPTIONS, TYPE_OPTIONS } from '../../shared/FilterBar';
import './FilmFilterBar.css';

interface FilmFilterBarProps {
  onDestinationChange?: (destination: string | null) => void;
  onTypeChange?: (type: string | null) => void;
}

const FilmFilterBar: React.FC<FilmFilterBarProps> = ({ 
  onDestinationChange, 
  onTypeChange 
}) => {
  const [selectedDestination, setSelectedDestination] = useState<string | undefined>(undefined);
  const [selectedType, setSelectedType] = useState<string | undefined>(undefined);

  const handleDestinationSelect = (destination: string) => {
    const newValue = destination === selectedDestination ? undefined : destination;
    setSelectedDestination(newValue);
    onDestinationChange?.(newValue || null);
  };

  const handleTypeSelect = (type: string) => {
    const newValue = type === selectedType ? undefined : type;
    setSelectedType(newValue);
    onTypeChange?.(newValue || null);
  };

  return (
    <div className="film-filter-section">
      <FilterBar
        className="film-collection-filters"
        dropdowns={[
          {
            id: 'destination',
            type: 'destination',
            level: 'brand',
            options: DESTINATION_OPTIONS,
            selectedValue: selectedDestination,
            onSelect: handleDestinationSelect
          },
          {
            id: 'type',
            type: 'type',
            level: 'brand',
            options: TYPE_OPTIONS,
            selectedValue: selectedType,
            onSelect: handleTypeSelect
          }
        ]}
        alignment="left"
      />
    </div>
  );
};

export default FilmFilterBar;